import { atom, useAtomValue } from 'jotai';

export const inViewIndexAtom = atom<number>(0);

export const useQuizInView = (index: number) => {
  const inViewIndex = useAtomValue(inViewIndexAtom);

  return inViewIndex === index;
};
